import { render } from "./DebugView.vue?vue&type=template&id=052a60f4&scoped=true"
import script from "./DebugView.vue?vue&type=script&lang=js"
export * from "./DebugView.vue?vue&type=script&lang=js"

import "./DebugView.vue?vue&type=style&index=0&id=052a60f4&scoped=true&lang=css"

import exportComponent from "/root/workspace/web--ming-pan_4MVO/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052a60f4"]])

export default __exports__